import PropTypes from "prop-types";

import {
  ALL_BUS_CATEGORIES_OPTIONS,
  EASY_NAVIGATION_TEXT,
} from "constants/common";

const RouteCategoryNote = ({ pageName }) => {
  return (
    <div className="bg-accent-back drop-shadow-lg rounded-md px-10 py-4 mt-12">
      <p className="my-4 italic">{EASY_NAVIGATION_TEXT}</p>

      <p className="my-4">The categories under this page are:</p>

      <ul className="my-4 list-disc pl-8">
        {ALL_BUS_CATEGORIES_OPTIONS[pageName].map(({ label, description }) => (
          <li className="my-3" key={label}>
            <span className="font-semibold"> {label} </span>:&nbsp;
            {description}
          </li>
        ))}
      </ul>
    </div>
  );
};

RouteCategoryNote.propTypes = {
  pageName: PropTypes.string,
};

export default RouteCategoryNote;
